export default () => ({
  allRiskClassifications: [],
  riskClassifications: [],
  error: null
})
